import NavigationLayout from "../navigation/navigationLayout";
import BannerView from "./banner/bannerView";
import HeroLayout from "./hero/heroLayout";
import StatsLayout from "./stats/statsLayout";
import TestimonialLayout from "./testimonial/testimonialLayout";
import UspLayout from "./usp/uspLayout";
import FooterLayout from '../footer/footerLayout';

const LandingLayout = () => {
    return (
        <>
            <NavigationLayout />

            <HeroLayout />

            <StatsLayout />

            <UspLayout />

            <BannerView />

            <TestimonialLayout />

            <FooterLayout needCloudTop={false}/>
        </>
    );
}

export default LandingLayout;